import { render, staticRenderFns } from "./appointmentXh.vue?vue&type=template&id=1320a57c&scoped=true&"
import script from "./appointmentXh.vue?vue&type=script&lang=js&"
export * from "./appointmentXh.vue?vue&type=script&lang=js&"
import style0 from "./appointmentXh.vue?vue&type=style&index=0&id=1320a57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320a57c",
  null
  
)

export default component.exports